module.exports = __webpack_public_path__ + "assets/f3601ec88cd50861f44b270e1b28ff9d.svg";